module.exports = ".ajout_espace {\n  margin-top: 70px; }\n"